<mat-toolbar class="main-toolbar">
  <mat-toolbar-row>
    <span class="logo-wrapper">
      <img class="logo" src="../../../../../assets/AZ_logo.png" alt="logo" />
    </span>
    <span class="fill-remaining-space"></span>
    <span>
      <button mat-button [matMenuTriggerFor]="menu" #menuTrigger>Menu</button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="openDialog()">Open dialog</button>
      </mat-menu>
    </span>
  </mat-toolbar-row>
</mat-toolbar>
